import React, { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { ChevronDown, Wrench, Code, Cloud } from 'lucide-react'
import { Link } from 'react-router-dom'

const ServicesDropdown = () => {
  const [isOpen, setIsOpen] = useState(false)

  const services = [
    { name: 'DevOps', href: '/services/devops', icon: Wrench },
    { name: 'Custom Software Development', href: '/services/custom-software-development', icon: Code },
    { name: 'Architecture', href: '/services/architecture', icon: Cloud },
  ]

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
        className="text-secondary hover:text-primary transition-colors duration-300 font-medium flex items-center gap-1"
      >
        Services
        <ChevronDown 
          size={16} 
          className={`transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} 
        />
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.2 }}
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
            className="absolute top-full left-0 mt-2 w-64 bg-background/95 backdrop-blur-md border border-gray-800 rounded-lg shadow-lg z-50"
          >
            <div className="py-2">
              {services.map((service) => (
                <Link
                  key={service.name}
                  to={service.href}
                  className="flex items-center gap-3 px-4 py-3 text-secondary hover:text-primary hover:bg-primary/10 transition-colors duration-300"
                  onClick={() => setIsOpen(false)}
                >
                  <service.icon size={18} className="text-primary" />
                  <span className="font-medium">{service.name}</span>
                </Link>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default ServicesDropdown
